module.exports = __webpack_public_path__ + "img/61.6a796d2e.jpg";